import { Flex } from 'libs/uikit/lib';
import React, { useState } from 'react';
import styled from 'styled-components';
import { ForgotPasswordForm } from './ForgotPasswordForm';
import { PasswordResetSentConfirmation } from './PasswordResetSentConfirmation';

const maxWidth = 500;

export function ForgotPasswordPage() {
  const [done, setDone] = useState<boolean>();

  return (
    <StyledPageLayout>
      <Flex gap={2} padding={1} align="stretch" style={{ maxWidth, margin: 'auto' }}>
        <img width={275} height={64} src={require('../Assets/logo.svg')} />

        {!done && <ForgotPasswordForm onComplete={() => setDone(true)} />}

        {done && <PasswordResetSentConfirmation />}
      </Flex>
    </StyledPageLayout>
  );
}

const StyledPageLayout = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;
